import '../../css/PopMessage.css'
import {useContext, useEffect} from 'react';
import {IPopMessageProps} from '../../interfaces/popMessageInterface'
import {AppContext} from '../context/AppContext';
import PopMessageDetailsContainer from './PopMessageDetailsContainer'
import PopMessageDetailsDiv from './PopMessageDetailsDiv';

const PopMessage = (props: IPopMessageProps) => {
    const {loaderProgress, loaderTotal} = props;
    const {disMessage} = useContext(AppContext);
    const [displayMessage]: string[] = disMessage;
    const [, setDisplayMessage]: React.Dispatch<React.SetStateAction<string>>[] = disMessage;

    useEffect(() => {
        if (displayMessage === "done") {
            setTimeout(() => {
                setDisplayMessage("none");
            }, 1500)
        }
    }, [displayMessage]);

    function onClose() {
        setDisplayMessage("none");
    }

    return (
        <div className='PopMessage'>
            {
                displayMessage === "asset-details" &&
                <div className='asset-details'>
                        <span className='asset-details-button-close' onClick={onClose}>
                            <i className="fas fa-times"></i>
                        </span>
                    <div className='asset-details-header'>
                        Asset Details
                    </div>
                    <PopMessageDetailsContainer
                        formData={props.formData}
                        type={props.type}
                        loadSensorData={props.loadSensorData}
                    />
                    <div className='asset-details-footer'>Are you Sure?</div>
                    <button className='asset-details-button-confirm' onClick={() => props.assetHandler()}>
                        Confirm
                    </button>
                </div>
            }
            {
                displayMessage === "processing" &&
                <div className='processing'>
                    <h2>Processing your request...</h2>
                    {Boolean(loaderProgress && loaderTotal) &&
                        <h2>finished process {loaderProgress} out of {loaderTotal} ...</h2>
                    }
                    <img className="spinner" src="/spinner-loading.gif" alt="spinner"/>
                </div>
            }
            {
                displayMessage === "done" &&
                <div className='done'>
                    <h2>Done!</h2>
                    <i className="far fa-check-circle done-icon"></i>
                </div>
            }
            {
                displayMessage === "error" &&
                <div className='error'>
                    <span className='error-button-close' onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </span>
                    {props.type !== "bulk" ?
                        <div className='error-body'>
                            <h2 >{props.errorTitle || "Error"}</h2>
                            <div style={{textAlign: 'left'}}>{props.error} </div>
                            {props.errorDescription && <p style={{ whiteSpace: 'break-spaces', textAlign: 'left' }}>
                                We're sorry, but we couldn't register your tracker. Possible reasons: <br />
                                &nbsp; 1. No cellular coverage in your area <br />
                                &nbsp; 2. Batteries were not inserted correctly <br /><br />
                                Note: It may take a few minutes for tracker to start communicating after battery insertion.

                            </p>}
                        </div>
                        :
                        <div className='error-body'>
                            <div className='error-body-description' style={{ whiteSpace: 'break-spaces', textAlign: "left" }}>{props.error} </div>
                            {props.errorList?.map((errorElement, i) => {
                                if (errorElement.elementName && errorElement.errorDescription) {
                                    return <PopMessageDetailsDiv
                                        key={i}
                                        divKey={errorElement.elementName}
                                        value={errorElement.errorDescription}
                                    />
                                }
                            })}
                        </div>
                    }
                </div>
            }
            {
                displayMessage === "info" &&
                <div className='error'>
                        <span className='error-button-close' onClick={onClose}>
                            <i className="fas fa-times"></i>
                        </span>
                    <div className='error-body'>
                        <h2>Info</h2>
                        <div>{props.error} </div>

                    </div>
                </div>
            }
            {
                displayMessage === "rename-successful" &&
                <div className='rename-successful'>
                    <h2>Rename asset completed successfully</h2>
                    <i className="far fa-check-circle done-icon"></i>
                </div>
            }
            {
                displayMessage === "deviceId-edit-error" &&
                <div className='deviceId-edit-error'>
                    <div>{`Device ID already assigned to asset "${props.assetInfoOfNewId?.assetName}".`}</div>
                    <div className='deviceId-edit-error-question-div'>{`Do you wish to reassign it?`}</div>
                    <div className='deviceId-edit-error-button-div'>
                        <button className='deviceId-edit-error-button' id='confirm-button'
                                onClick={props.deviceIdReplaceHandler}>
                            Confirm
                        </button>
                        <button className='deviceId-edit-error-button' id='cancel-button'
                                onClick={props.deviceIdReplaceHandler}>
                            Cancel
                        </button>

                    </div>
                </div>
            }
            {
                displayMessage === "deviceId-reassigned" &&
                <div className='done'>
                    <h2>Done!</h2>
                    <i className="far fa-check-circle done-icon"></i>
                </div>
            }
            {
                displayMessage === "bulk-load" &&
                <div className='asset-details'>
                        <span className='asset-details-button-close' onClick={onClose}>
                            <i className="fas fa-times"></i>
                        </span>
                    <div className='asset-details-header'>
                        File details
                    </div>
                    <div className='asset-details-data-container'>
                        {props.formData.fileName &&
                            <PopMessageDetailsDiv divKey={"File name"}
                                                  value={props.formData.fileName}
                            />
                        }
                    </div>
                    <div className='asset-details-footer'>Are you Sure you want to upload this file?</div>
                    <button className='asset-details-button-confirm' onClick={() => props.assetHandler()}>
                        Confirm
                    </button>
                </div>
            }
            {
                displayMessage === "add-update-location" &&
                <div className='add-update-location'>
                        <span className='asset-details-button-close' onClick={onClose}>
                            <i className="fas fa-times"></i>
                        </span>
                    {(props.formData.fileNamesList && props.formData.fileNamesList.length !== 0) &&
                        <>
                            <div className='asset-details-header'>
                                File details
                            </div>
                            <div className='asset-details-data-container'>
                                <PopMessageDetailsDiv divKey={"Add/Update Locations"}
                                                      value=" "
                                />
                                <ul>
                                    {props.formData.fileNamesList.map((name) => {
                                        return <li>{name}</li>
                                    })}
                                </ul>
                                {props.type !== "" &&
                                    <PopMessageDetailsDiv divKey={"Location Type"}
                                                          value={props.type}
                                    />
                                }
                            </div>
                        </>

                    }
                    <div
                        className={props.formData.fileNamesList?.length !== 0 ? "asset-details-footer" : 'asset-location-footer-no-details'}>
                        Are you Sure you want to upload this file?
                    </div>
                    <button className='asset-details-button-confirm' onClick={() => props.assetHandler()}>
                        Confirm
                    </button>
                </div>
            }
            {
                displayMessage === "add-update-location-error" &&
                <div className='error'>
                    <span className='error-button-close' onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </span>
                    <div className='error-body'>
                        {props.messageStatus ?
                            <h2>Add/Update Successfully</h2>
                            :
                            <h2>Error</h2>
                        }
                        <div className='error-body-description'>{props.error} </div>
                        {
                            props.errorList?.map((errorElement) => {
                                if (errorElement.elementName && errorElement.errorDescription) {
                                    return <PopMessageDetailsDiv
                                        divKey={errorElement.elementName} value={errorElement.errorDescription}
                                    />
                                }
                            })
                        }
                    </div>

                </div>
            }
            {
                displayMessage === "warning" &&
                <div className='error'>
                        <span className='error-button-close' onClick={onClose}>
                            <i className="fas fa-times"></i>
                        </span>
                    <div className='error-body'>
                        <h2>Warning</h2>
                        <div>{"Device can only be waken-up using knock mechanism, or by power reset"}</div>

                    </div>

                </div>
            }
        </div>
    );
};


export default PopMessage;